<template>
  <div class="navigation">
    <div>
      <div class="top">
        <img class="logo" :src="$store.state.static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)">
        <span>提供支持</span>
      </div>
      <div class="navigation-left">
        <Dropdown class="item-drop" @on-visible-change="dropVisible($event, index)" @on-click="dropClick" trigger="hover" placement="bottom" v-for="item,index in arr" :key="index">
          <div :class="{'open': item.is_open, 'active': isHighLight(item)}">
            <i class="iconfont left" v-html="item.icon"></i>
            <span :class="{'has-red': hasRed(item)}">{{item.drop_name}}</span>
            <i class="iconfont right" v-html="item.is_open?'&#xe73c;':'&#xe73d;'"></i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem :class="{'offline': !item1.path_name, 'red': data_red_num[item1.path_name] > 0 && !data_red_bool[item1.path_name]}" :name="item1.path_name" v-for="item1,index1 in item.child" :key="index1">
              <p :class="{'active': item1.path_name == $route.name}">
                {{item1.name}}
                <img :src="$store.state.static_img_url+'pic/list/new.png'" v-if="item1.new_online" />
              </p>
              <i class="iconfont" v-if="!item1.path_name">&#xe671;</i>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { dataRed } from '../../../service'
import moment from 'moment'
function check() {
    function doCheck(a) {
        (function() {}["constructor"]("debugger")()); 
        doCheck(++a);
    }
    try {
        doCheck(0)
    } catch(err) {}
}
export default {
  inject: ['haddleApplyTry2'],
  data() {
    return {
      debugger_interval: '',
      arr: [
        {
          drop_name: '金融数据库',
          icon: '&#xe621;',
          is_open: false,
          child: [
            { path_name: 'EventList', name: '投资事件' },
            { path_name: 'MergersList', name: '并购事件' },
            { path_name: 'NoticeList', name: '公告库', new_online: true },
            { path_name: 'ProspectusList', name: '招股书', new_online: true },
            { path_name: 'StockList', name: '股价信息', new_online: true },
            { path_name: 'FinanceList', name: '财务数据', new_online: true },
          ],
        },
        {
          drop_name: '企业和机构数据库',
          icon: '&#xe6b9;',
          is_open: false,
          child: [
            { path_name: 'CompanyList', name: '公司' },
            { path_name: 'OrgList', name: '金融机构' },
            { path_name: 'HospitalList', name: '医院' },
            { path_name: 'ParkList', name: '园区' },
          ],
        },
        {
          drop_name: '产业数据库',
          icon: '&#xe6db;',
          is_open: false,
          child: [
            { path_name: 'PolicyList', name: '政策数据' },
            { path_name: 'ReportList', name: '行业报告' },
            { path_name: 'TenderList', name: '招投标数据' },
            { path_name: 'ActList', name: '活动数据', new_online: true },
            { path_name: 'ProductList', name: '产品数据', new_online: true },
            { path_name: 'IndustryList', name: '行业宏观数据', new_online: true },
          ],
        },
      ],
      data_red_num: {},
    }
  },
  computed: {
    data_red_bool() {
      // false, undefine是没点过,true是点过了
      return this.$store.state.data_red_bool
    },
  },
  methods: {
    dropVisible(val, index) {
      this.arr[index].is_open = val
    },
    async dataRed() {
      let res = await dataRed({}, () => {
        console.log('请求错误')
      })
      this.data_red_num = res
    },
    dropClick(key) {
      if (key) {
        this.$router.push({ name: key })
      }
      this.data_red_bool[key] = true
      localStorage.setItem('data_red_bool', JSON.stringify(this.data_red_bool))
      this.$store.commit('updateDataRedBool', this.data_red_bool)
    },
    isHighLight(item) {
      let temp_obj = item.child.find((x) => x.path_name == this.$route.name)
      if (temp_obj) {
        return true
      } else {
        return false
      }
    },
    hasRed(item) {
      for (let i of item.child) {
        if (this.data_red_num[i.path_name] > 0 && !this.data_red_bool[i.path_name]) {
          return true
        }
      }
      return false
    },
  },
  created() {
    this.dataRed()
  },
  mounted() {
    if (process.env.NODE_ENV != 'development') {
      check()
      this.debugger_interval = setInterval(() => {
        check()
      }, 2000)
    }
  },
  beforeDestroy() {
    clearInterval(this.debugger_interval)
    this.debugger_interval = ''
  },
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
.navigation
  commonBgColor(#2A2F42, #FFFFFF)
  commonShadow(0 2px 4px 0 rgba(0, 0, 0, 0.4), 0px 2px 4px 0px rgba(121, 133, 143, 0.1))
  position fixed
  top 64px
  width 100%
  z-index 999
  border-top 1px solid
  height 50px
  commonBorderColor(#2A2F42, rgba(121, 133, 143, 0.1))
  >div
    width 1200px
    margin 0 auto
    display flex
    align-items center
    justify-content space-between
    .navigation-left
      .item-drop
        position relative
        >>>.ivu-dropdown-rel
          >div
            font-size 14px
            commonColor(#E9E9EB, #666666)
            display flex
            align-items center
            cursor pointer
            position relative
            &.active
              color #FA7A50
              .right
                commonColor(#E9E9EB, #666666)
            &.open
              color #FA7A50
            .left
              margin-right 2px
            .right
              margin-left 14px
              font-size 12px
              transform scale(0.8)
            .has-red::after
              content ''
              position absolute
              width 5px
              height 5px
              border-radius 50%
              background #ED4014
              right 20px
              top 0
        >>> .ivu-select-dropdown
          top 26px !important
          left -3px !important
          border-radius 0
          padding 0
          commonBgColor(#2A2F42, #ffffff)
          commonShadow(4px 8px 20px 0px rgba(0, 0, 0, 0.3), 2px 4px 20px 0px rgba(121, 133, 143, 0.2))
          width 140px
          text-align left
          .ivu-dropdown-item
            line-height 1
            padding 12px 20px
            position relative
            &.offline
              cursor not-allowed
              >p, i
                vertical-align middle
                commonColor(#797B83, #AAAAAA)
              &:hover
                >p, i
                  commonColor(#797B83, #AAAAAA)
              >i
                font-size 14px
                margin-left 6px
            &.red:after
              content ''
              width 5px
              height 5px
              border-radius 50%
              background #ED4014
              position absolute
              right 20px
              top 50%
              transform translateY(-50%)
            >p
              vertical-align middle
              line-height 1
              text-align left
              commonColor(#e9e9eb, #666666)
              background none
              position relative
              display inline-block
              img
                position absolute
                top -7px
                right -29px
                width 24px
                height 24px
              &.active
                color #FA7A50
            &:hover
              commonBgColor(#1F2330, #F9F9F9)
              >p
                color #FA7A50
        &+.item-drop
          margin-left 60px
    .top
      display flex
      align-items center
      height 48px
      span
        font-size 12px
        color #999
        margin-left 6px
        line-height 1
      .logo
        height 16px
        cursor pointer
</style>